import React from "react";
import { PusherProvider } from "./Pusher/pusher.context";
import { PaymentProvider } from "./Payment/payment.context";
import  ViewProvider  from "./view.context";
import UrlAuthProvider from "./urlauth.context";
import UrlBodyProvider from "./urlBody.context";

const Provider = ({ children }) => (
  <PaymentProvider>
   <ViewProvider>
   <UrlAuthProvider>
   <UrlBodyProvider>
   <PusherProvider>{children}</PusherProvider>
  </UrlBodyProvider>
   </UrlAuthProvider>
   </ViewProvider>
  </PaymentProvider>
);

export default Provider;
